export default {
  c_uuid: 'c_uuid',
  customer_assigned_ts: 'i2p2_state/customer_assigned_ts',
  first_online_ts: 'i2p2_state/first_online_ts',
  c_name: 'c_identity/c_name',
  p_type: 'p_type',
  vendor_serial: 'c_identity/vendor[0]/v_values/vendor_serial',
  product_serial: 'c_identity/product_serial_number',
  c_status: 'i2p2_state/c_status',
  c_online: 'i2p2_state/c_online',
  changed_online_status: 'charger/changed_online_status',
  connector_state: 'c_full_state/connector_state',
  c_owner: 'c_exploitation_info/c_owner',
  c_supervisor: 'c_exploitation_info/c_supervisor',
  c_maintainer: 'c_exploitation_info/c_maintainer',
  c_nickname: 'c_exploitation_info/c_nickname',
  c_warranty_end: 'c_exploitation_info/c_warranty_end',
  c_country: 'c_identity/c_country',
  c_latitude: 'c_identity/c_latitude',
  c_longitude: 'c_identity/c_longitude',
  c_utc: 'c_identity/c_utc',
  picture_keys: 'c_identity/picture_keys',
  c_product_version: 'c_technical_information/c_product_version',
  c_enclosure: 'c_technical_information/c_enclosure',
  c_product_level: 'c_technical_information/c_product_level',
  c_gir_reboot: 'c_technical_information/c_gir_reboot',
  ports_0_p_status: 'i2p2_state/ports[0]/p_status',
  ports_1_p_status: 'i2p2_state/ports[1]/p_status',
  ports_2_p_status: 'i2p2_state/ports[2]/p_status',
  ports_3_p_status: 'i2p2_state/ports[3]/p_status',
  c_port_names_0_c_port_names: 'c_i2p2_configuration/c_port_names[0]',
  c_port_names_1_c_port_names: 'c_i2p2_configuration/c_port_names[1]',
  c_port_names_2_c_port_names: 'c_i2p2_configuration/c_port_names[2]',
  c_port_names_3_c_port_names: 'c_i2p2_configuration/c_port_names[3]',
  c_product_levels: 'admin_tools/c_product_levels',
  board_reset: 'charger/board_reset',
  pwb1_reset: 'charger/pwb1_reset',
  gir_reset: 'charger/gir_reset',
  notification_reset: 'charger/notification_reset',
  fw_update: 'charger/fw_update',
  fw_update_applied: 'activity/fw_update_applied',
  c_address: 'c_identity/c_address',
  c_chademo_cable: 'c_technical_information/c_chademo_cable',
  module_status: 'c_full_state/vendor/module_status',
  c_condition: 'i2p2_state/c_condition',
  c_ac_hw_version: 'c_technical_information/c_ac_hw_version',
  c_contact: 'c_exploitation_info/c_contact',
  configuration: 'configuration',
  notes: 'c_exploitation_info/notes',
  customer_id: 'customer_id',
  lifecycle_status_draft: 'draft',
  lifecycle_status_deploying: 'deploying',
  lifecycle_status_operational: 'operational',
};
